var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3789 26.4404C11.9301 27.1374 12.6325 27.7 13.4329 28.0858C14.2334 28.4716 15.1111 28.6704 15.9997 28.6672C16.8883 28.6704 17.766 28.4716 18.5665 28.0858C19.367 27.7 20.0693 27.1374 20.6205 26.4404C17.554 26.8555 14.4455 26.8555 11.3789 26.4404Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5497 13.0914V12.1997C24.5497 7.30274 20.7206 3.33301 15.9997 3.33301C11.2788 3.33301 7.44969 7.30274 7.44969 12.1997V13.0914C7.44969 14.1617 7.14569 15.208 6.57315 16.0985L5.16969 18.2809C3.88909 20.2747 4.86695 22.9841 7.09502 23.6136C12.917 25.2624 19.0824 25.2624 24.9044 23.6136C27.1324 22.9841 28.1103 20.2747 26.8297 18.2809L25.4262 16.0985C24.8522 15.2007 24.5488 14.1571 24.5497 13.0914ZM15.9997 7.44967C16.2516 7.44967 16.4933 7.54976 16.6714 7.72792C16.8496 7.90608 16.9497 8.14772 16.9497 8.39967V13.4663C16.9497 13.7183 16.8496 13.9599 16.6714 14.1381C16.4933 14.3163 16.2516 14.4163 15.9997 14.4163C15.7477 14.4163 15.5061 14.3163 15.3279 14.1381C15.1498 13.9599 15.0497 13.7183 15.0497 13.4663V8.39967C15.0497 8.14772 15.1498 7.90608 15.3279 7.72792C15.5061 7.54976 15.7477 7.44967 15.9997 7.44967Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.16d60a69d5586b268533750df6228fa6.svg";
export { ForwardRef as ReactComponent };